import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withTheme } from '@material-ui/core/styles';
import {Typography} from '@material-ui/core';

class ProgressBar extends PureComponent {

  getPctComplete = () => {
    const pct = Math.round((this.props.index / this.props.size ) * 100 );
    return (pct === 0 || !pct) ? '': `${pct}%`
  };
  render() {
    const { width, index, size, theme, height=16, style, noGrad, wantPct } = this.props;
    const complete = (index >= size);
    return(
      <div
        style={{
          height,
          width: wantPct ? '100%': width,
          maxWidth: '100%',
          borderRadius: 4,
          backgroundColor: theme.palette.color2.opacity50,
          transition: 'background-color 1.2s',
          display: 'flex',
          alignItems: 'center',
          ...style,
        }}
      >
        <div
          style={{
            height,
            width: wantPct ? this.getPctComplete() : ((index + 1)/size) * (width),
            borderRadius: 4,
            transition: 'width 1s, background-color 1.4s',
            backgroundImage: !noGrad && `linear-gradient(to right, ${theme.palette.secondary.dark}, ${theme.palette.secondary.main})`,
            backgroundColor: (noGrad && !complete) ? theme.palette.color2.opacity100: theme.palette.color9.opacity100,
          }}
        />
        {(wantPct && !complete) &&
          <Typography
            variant="caption"
            style={{
              textAlign: 'right',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              marginLeft: 8,
            }}>
            {this.getPctComplete()}
          </Typography>
        }
      </div>
    );
  }
}

ProgressBar.propTypes = {
  width: PropTypes.number, // width (in pixels) of the progress bar
  height: PropTypes.number, // height (in pixels) of the progress bar (defaults to 20)
  index: PropTypes.number, // current index (like 1 out of 5)
  size: PropTypes.number, // total amount of steps (like 5)
  theme: PropTypes.object,
  wantPct: PropTypes.bool, // show percentage complete
  noGrad: PropTypes.bool, // show flat style, no gradient
  style: PropTypes.object, // any styles overrides are passed down
};

export default compose(withTheme)(ProgressBar);
